import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useParams } from '@tanstack/react-router';
import { RuleAndPolicyContent } from '@/features/rule-and-policy/-components';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { orpc } from '@/lib/api/orpc';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { useSoftware } from '../-query';
export const Route = createFileRoute('/_staff/software/$id/_$id/rule-and-policy/')({
  component: RuleAndPolicy
});
function RuleAndPolicy() {
  const {
    id: softwareId
  } = useParams({
    from: '/_staff/software/$id/_$id/rule-and-policy/'
  });
  const {
    data: softwareData
  } = useSoftware(softwareId);
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.profile.app.ruleAndPolicy'
  });
  useDocumentTitle(t('pageTitle', {
    name: softwareData.info.name,
    interpolation: {
      escapeValue: false
    }
  }));
  if (softwareData.appIntegrationId === null) {
    return <RuleAndPolicyContent softwareId={softwareId} />;
  }
  return <IntegrationRuleAndPolicy softwareId={softwareId} />;
}

// AppIntegration 持ち Software は overviewAppContract から
// canRetrieveUserGroup / canRetrieveSubGroup を解決してサイドメニューの
// group / license タブ表示制御に渡す。query は Header / settings sidebar
// と TanStack Query で dedupe される。
function IntegrationRuleAndPolicy({
  softwareId
}: {
  softwareId: string;
}) {
  const {
    data
  } = useSuspenseQuery(orpc.software.overviewAppContract.queryOptions({
    input: {
      softwareId
    }
  }));
  return <RuleAndPolicyContent softwareId={softwareId} canRetrieveSubGroup={data.canRetrieveSubGroup} canRetrieveUserGroup={data.canRetrieveUserGroup} />;
}